/**
 * アバターの定数定義
 */
export namespace AvatarCode {
  // none
  export const AVATAR_NONE = {
    code: 'avatar_none',
    path: '/img/avatar/avatar_none.png',
  }
  // 1
  export const AVATAR_1 = {
    code: 'avatar_1',
    path: '/img/avatar/avatar_1.svg',
  }

  // 2
  export const AVATAR_2 = {
    code: 'avatar_2',
    path: '/img/avatar/avatar_2.svg',
  }

  // 3
  export const AVATAR_3 = {
    code: 'avatar_3',
    path: '/img/avatar/avatar_3.svg',
  }

  // 4
  export const AVATAR_4 = {
    code: 'avatar_4',
    path: '/img/avatar/avatar_4.svg',
  }

  // アバターのリスト
  export const LIST = [AVATAR_NONE, AVATAR_1, AVATAR_2, AVATAR_3, AVATAR_4]

  /**
   * codeの値から該当する定数を見つけて返す
   *
   * @param code アバターのcode
   * @returns アバターの定数
   */
  export function findByCode(code: string | null): AvatarMaster {
    // codeがnullの場合の規定値を返す
    if (!code) {
      return AVATAR_NONE
    }

    const avatar = LIST.find((avatar) => avatar.code === code)

    if (!avatar) {
      return AVATAR_NONE
    }

    return avatar
  }

  /**
   * アバターアイコンのマスター
   */
  export type AvatarMaster = {
    /** コード */
    code: string
    /** パス */
    path: string
  }
}
